'use client';

import React from 'react';
import type { ChatMessageListProps } from './types';

const DEFAULT_CONTENT_CLASS = 'max-w-3xl mx-auto px-4 py-6 flex flex-col gap-6';

const ChatMessageList: React.FC<ChatMessageListProps> = ({
  className = '',
  contentClassName,
  'aria-label': ariaLabel = 'Chat messages',
  role = 'log',
  'data-testid': testId,
  children,
  bottomRef,
}) => (
  <div
    className={`flex-1 overflow-y-auto ${className}`}
    aria-label={ariaLabel}
    role={role}
    data-testid={testId}
  >
    <div className={contentClassName ?? DEFAULT_CONTENT_CLASS}>
      {children}
      {bottomRef && <div ref={bottomRef} aria-hidden="true" />}
    </div>
  </div>
);

export default ChatMessageList;
